import { NgOptimizedImage, UpperCasePipe } from '@angular/common';
import { Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'app-report-status',
  imports: [NgOptimizedImage, UpperCasePipe],
  templateUrl: './report-status.component.html',
  styleUrl: './report-status.component.scss'
})
export class ReportStatusComponent {
  risk: InputSignal<string> = input.required();

}
